import { Injectable } from "@angular/core";
import { fromEvent } from "rxjs";

/** Testability layer for the native localStorage API.  Always use this instead of accessing localStorage directly. */
@Injectable({ providedIn: "root" })
export class LocalStorageService {
  public storageChanged$ = fromEvent(window, "storage");

  public getItem(key: string): string | null {
    return localStorage.getItem(key);
  }

  public setItem(key: string, value: string): void {
    localStorage.setItem(key, value);
  }

  public removeItem(key: string): void {
    localStorage.removeItem(key);
  }
}
